import { jsx as r } from "@emotion/react/jsx-runtime";
import { useId as _, useRef as E, useContext as k, createContext as p, useState as I, useEffect as v, useMemo as L } from "react";
import { AnimatePresence as M } from "motion/react";
import { createPortal as N } from "react-dom";
import { Overlay as P, ModalContainer as S, ChildrenContainer as H, MODAL_ANIMATIONS_IN_MS as R } from "./Modal.styled.js";
const s = p({
  setActiveChild: () => {
  }
}), f = (c, d, o, e) => {
  const n = (t) => {
    c(t) && d();
  };
  v(() => (e[0] && document.addEventListener(o, n), () => {
    e[0] && document.removeEventListener(o, n);
  }), e);
}, D = ({
  containerRef: c,
  placement: d = "default",
  animation: o = "slideTop",
  hideOnClickOutside: e = !0,
  hideOnEsc: n = !0,
  isOpen: t,
  children: C,
  closeModal: i,
  overlayAppearance: h = "dark"
}) => {
  const m = _(), l = E(null), {
    setActiveChild: A
  } = k(s), [a, x] = I(!1);
  v(() => {
    A(t);
  }, [t]), f((u) => t && l.current === u.target && !a, i, "click", [e, t, l, a, i]), f((u) => t && u.key === "Escape" && !a, i, "keydown", [n, t, a, i]);
  const y = L(() => ({
    setActiveChild: x
  }), []);
  return /* @__PURE__ */ r(s.Provider, { value: y, children: N(/* @__PURE__ */ r(M, { children: t && /* @__PURE__ */ r(P, { ref: l, appearance: h, initial: {
    opacity: 0
  }, animate: {
    opacity: 1
  }, exit: {
    opacity: 0
  }, transition: {
    duration: R / 1e3
  }, children: /* @__PURE__ */ r(S, { placement: d, animation: o, children: /* @__PURE__ */ r(H, { children: C }) }) }, `modal__${m}`) }), c ?? document.body, `modal__${m}`) });
};
export {
  D as Modal
};
